import { TreePickerSingleDirectionEnum } from './../tree-picker-single/tree-picker-single.component';
import { ITreePickerElement } from './../../../../interfaces/tree-picker.interface';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreePickerSingleDirectionType } from '../tree-picker-single/tree-picker-single.component';

@Component({
  selector: 'siu-tree-picker-item-simple',
  templateUrl: './tree-picker-item-simple.component.html',
  styleUrls: [ './tree-picker-item-simple.component.scss' ]
})
export class TreePickerItemSimpleComponent implements OnInit {

  @Input() data: ITreePickerElement;
  @Input() offsetText: number;
  @Output('on-add') OnAddEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-remove') OnRemoveEvent: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean;
  @Input() direction: TreePickerSingleDirectionType;
  @Input() readonly: boolean = false;
  @Input() sideDirection: 'ltr' | 'rtl' = 'ltr';

  constructor() { }

  ngOnInit() {
  }

  HandleAddItem = () => {
    this.OnAddEvent.emit(this.data);
  }

  HandleRemoveItem = () => {
    this.OnRemoveEvent.emit(this.data);
  }

  ItemDisabled = (nodeDisabled: boolean, itemSelected: boolean) => {
    if (this.direction === TreePickerSingleDirectionEnum.INPUT)
      return nodeDisabled;
    else
      return !itemSelected;
  }
}
